import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  formDataPost,
  formDataPut,
  get,
  patch,
  post,
  put,
} from "helpers/api_helper"
import {
  ADD_FAQ,
  DELETE_FAQ,
  GET_ALL_FAQ,
  GET_FAQ_DETAILS,
  GET_PAGE_CONTENT_BY_TYPE,
  UPDATE_FAQ,
  UPDATE_FAQ_STATUS,
  UPDATE_PAGE_CONTENT_BY_TYPE,
} from "helpers/url_helper"

export const getAllFaq = createAsyncThunk(GET_ALL_FAQ, async payload => {
  const response = await post(GET_ALL_FAQ, payload)
  return response
})

export const updateFaqStatus = createAsyncThunk(
  UPDATE_FAQ_STATUS,
  async payload => {
    const response = await patch(UPDATE_FAQ_STATUS, payload)
    return response
  }
)

export const addFaq = createAsyncThunk(ADD_FAQ, async payload => {
  const response = await post(ADD_FAQ, payload)
  return response
})

export const getFaqDetails = createAsyncThunk(
  GET_FAQ_DETAILS,
  async payload => {
    const response = await post(GET_FAQ_DETAILS, payload)
    return response
  }
)

export const updateFaq = createAsyncThunk(UPDATE_FAQ, async payload => {
  const response = await put(UPDATE_FAQ, payload)
  return response
})

export const deleteFaq = createAsyncThunk(DELETE_FAQ, async payload => {
  const response = await del(`${DELETE_FAQ}`, payload)
  return response
})

// export const getCountryList = createAsyncThunk(
//   GET_ALL_COUNTRY_LIST,
//   async payload => {
//     const response = await get(GET_ALL_COUNTRY_LIST, payload)
//     return response
//   }
// )

export const getPageContentByType = createAsyncThunk(
  GET_PAGE_CONTENT_BY_TYPE,
  async payload => {
    const response = await post(GET_PAGE_CONTENT_BY_TYPE, payload)
    return response
  }
)


export const updatePageContentByType = createAsyncThunk(
  UPDATE_PAGE_CONTENT_BY_TYPE,
  async payload => {
    const response = await post(UPDATE_PAGE_CONTENT_BY_TYPE, payload)
    return response
  }
)
